import { OrdersText, OrderText, UnavailableDataPlaceholderText } from "constants/text";
import { StopAddress, StopDetailsContainer, StopNumber } from "./StopDetails.styles";
import { models } from "types/api/viewModels";

interface StopDetailsProps {
	stop: models["TruckStopViewModel"];
	index: number;
}

const StopDetails = ({ stop, index }: StopDetailsProps) => {
	return (
		<StopDetailsContainer data-testid={`stop-details-${index}`}>
			<div>
				<StopNumber data-testid={`stop-number-${index}`}>Stop #{index + 1}</StopNumber>
				<StopAddress data-testid={`stop-address-${index}`}>
					{stop.address
						? `${stop.address.name ?? ""}, ${stop.address.line1 ?? ""}${stop.address.line2 ?? ""}, ${stop.address.city ?? ""}, ${stop.address.state ?? ""} ${stop.address.zip ?? ""}`
						: UnavailableDataPlaceholderText}
				</StopAddress>
			</div>
			<span data-testid={`stop-draft-orders-count-${index}`}>
				{stop.draftOrders?.length} {stop.draftOrders?.length === 1 ? OrderText : OrdersText}
			</span>
		</StopDetailsContainer>
	);
};

export default StopDetails;
